<div class="row" *ngIf="!loading">
  <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6">
    <div class="card">
      <div class="row">
        <div class="col-4 d-flex align-items-center">
          <h3 class="card-title text-nowrap">{{ 'product-form.information' | translate }}</h3>
        </div>
        <div class="col-8 d-flex justify-content-end">
          <div class="flex-gap-5">
            <form-row-checkbox
              [label]="'product.enabled'"
              [(model)]="productDetailService.product.enabled"
              [inputDisabled]="!productDetailService.hasUpdateRole"
            >
            </form-row-checkbox>
          </div>
        </div>
      </div>
      <div class="card-body p-0 row">
        <div class="col-12 mt-2">
          <form-row-input
            [label]="'product.name'"
            [icon]="'far-file-alt'"
            [(model)]="productDetailService.product.name"
            [required]="!product.name"
            [requiredCssClass]="submitted && !product.name"
            [readonly]="!productDetailService.hasUpdateRole"
            data-cy="product-name"
          ></form-row-input>
        </div>
        <div class="col-6">
          <form-row-input
            [label]="'product.code2'"
            [icon]="'far-tag'"
            [(model)]="productDetailService.product.code2"
            [readonly]="!productDetailService.hasUpdateRole"
            data-cy="product-code"
          ></form-row-input>
          <form-row-input
            [label]="'product.code'"
            [icon]="'far-tag'"
            [(model)]="productDetailService.product.code"
            [readonly]="!productDetailService.hasUpdateRole"
            data-cy="product-code"
          ></form-row-input>
          <form-row-input
            [label]="'product.code3.label'"
            [icon]="'far-tag'"
            [(model)]="productDetailService.product.code3"
            [readonly]="!productDetailService.hasUpdateRole"
            data-cy="product-code"
          ></form-row-input>
          <form-row-select
            [label]="'product.mdClass'"
            [options]="mdClassOptions"
            [model]="productDetailService.selectedMdClass"
            (modelChange)="onMdClassChange($event)"
            [isSelectDisabled]="!productDetailService.hasUpdateRole"
            data-cy="product-md-class"
          ></form-row-select>
        </div>
        <div class="col-6">
          <div class="d-flex">
            <form-row-input
              class="width-81"
              [label]="'product.ean'"
              [icon]="'far-barcode'"
              [translateBarcode]="false"
              [(model)]="productDetailService.product.ean"
              [appendBtnIcon]="!product.ean || product.ean?.length === 0 ? 'fa-barcode' : ''"
              [appendBtnLabel]="!product.ean || product.ean?.length === 0 ? 'product.ean.generate' : ''"
              [appendBtnClasses]="['btn-ean']"
              (onAppendBtnEvent)="fillNextEan()"
              [readonly]="!productDetailService.hasUpdateRole"
              data-cy="product-ean"
            ></form-row-input>
            <div style="margin-top: 1.2rem">
              <btn
                class="print-btn"
                *ngIf="!isCreating && this.product.ean?.length"
                [classes]="['btn-first']"
                (onEvent)="openBarcode()"
                [icon]="'fa-print'"
                [label]="'print'"
                [title]="'print' | translate"
              ></btn>
            </div>
          </div>
          <form-row-input
            [label]="'product.ean2'"
            [icon]="'fa-barcode'"
            [(model)]="productDetailService.product.ean2"
            [translateBarcode]="false"
            [readonly]="!productDetailService.hasUpdateRole"
            *ngIf="!!product.ean || !!product.ean2"
          ></form-row-input>
          <form-row-input
            [label]="'product.ean3'"
            [icon]="'fa-barcode'"
            [(model)]="productDetailService.product.ean3"
            [translateBarcode]="false"
            [readonly]="!productDetailService.hasUpdateRole"
            *ngIf="!!product.ean2 || !!product.ean3"
          ></form-row-input>
          <form-row-input
            [label]="'product.ean4'"
            [icon]="'fa-barcode'"
            [(model)]="productDetailService.product.ean4"
            [readonly]="!productDetailService.hasUpdateRole"
            *ngIf="!!product.ean3 || !!product.ean4"
            [translateBarcode]="false"
          ></form-row-input>
          <form-row-input
            [label]="'product.ean5'"
            [icon]="'fa-barcode'"
            [(model)]="productDetailService.product.ean5"
            [readonly]="!productDetailService.hasUpdateRole"
            *ngIf="!!product.ean4 || !!product.ean5"
            [translateBarcode]="false"
          ></form-row-input>
        </div>
        <div class="col-12">
          <div class="row">
            <div class="col-12">
              <h2 class="card-title">{{ 'description' | translate }}</h2>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-12">
              <ckeditor
                [editor]="ckeditor"
                [(ngModel)]="productDetailService.product.description"
                [ngModelOptions]="{ standalone: true }"
                data-cy="product-note"
              ></ckeditor>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6">
    <!--      HIDE PARENT-->
    <!--      <div class="row">-->
    <!--        <div class="col-12">-->
    <!--          <div class="card" *ngIf="!product.children || (product.children && !product.children.length)">-->
    <!--            <div class="row">-->
    <!--              <div class="col-12 col-sm-6 align-self-center">-->
    <!--                <label class="card-title text-nowrap">-->
    <!--                  {{ 'product.parent' | translate }}-->
    <!--                </label>-->
    <!--              </div>-->
    <!--              <div class="col-12 col-sm-6 d-flex mt-2 mt-sm-0 flex-sm-row-reverse">-->
    <!--                <modal-product-parent-->
    <!--                  [product]="product"-->
    <!--                  [depots]="depots"-->
    <!--                  [suppliers]="suppliers"-->
    <!--                  [btnText]="'product.choose'"-->
    <!--                  *ngIf="productDetailService.hasUpdateRole"-->
    <!--                  (result)="setParent($event)"-->
    <!--                ></modal-product-parent>-->
    <!--              </div>-->
    <!--            </div>-->
    <!--            <div class="mt-2" *ngIf="!!product.parent && product.parent?.id > 0">-->
    <!--              <table class="table">-->
    <!--                <tbody>-->
    <!--                  <div class="table-product-border">-->
    <!--                    <tr>-->
    <!--                      <td class="border-0 td-left-radius w-100">-->
    <!--                        <div class="flex-gap-10 align-items-center">-->
    <!--                          <product-image [product]="product.parent"></product-image>-->
    <!--                          <div>-->
    <!--                            <a class="link-bold" [routerLink]="['/product', product.parent.id]">{{-->
    <!--                              product.parent.name-->
    <!--                            }}</a>-->
    <!--                            <div class="product-details flex-gap-5 flex-wrap">-->
    <!--                              <div *ngIf="product.parent.code">-->
    <!--                                {{ 'product.code' | translate }}: {{ product.parent.code }}-->
    <!--                              </div>-->
    <!--                              <div *ngIf="product.parent.ean">-->
    <!--                                {{ 'product.ean' | translate }}: {{ product.parent.ean }}-->
    <!--                              </div>-->
    <!--                            </div>-->
    <!--                          </div>-->
    <!--                        </div>-->
    <!--                      </td>-->
    <!--                      <td class="border-0 td-right-radius">-->
    <!--                        <btn-->
    <!--                          [title]="'delete' | translate"-->
    <!--                          [icon]="'far-trash-alt'"-->
    <!--                          [classes]="['btn-trash', 'btn-sm', 'float-right']"-->
    <!--                          (onEvent)="productDetailService.product.parent = null"-->
    <!--                          *ngIf="productDetailService.hasUpdateRole"-->
    <!--                        ></btn>-->
    <!--                      </td>-->
    <!--                    </tr>-->
    <!--                  </div>-->
    <!--                </tbody>-->
    <!--              </table>-->
    <!--            </div>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </div>-->

    <!--      HIDE CHILDREN-->
    <!--      <div class="row">-->
    <!--        <div class="col-12">-->
    <!--          <div class="card" *ngIf="((product.children && product.children.length > 0) || !product.parent)">-->
    <!--            <div>-->
    <!--              <div class="row">-->
    <!--                <div class="col-5 d-flex align-items-center">-->
    <!--                  <label class="card-title">{{ 'product.children' | translate }}</label>-->
    <!--                </div>-->
    <!--                <div *ngIf="!isCreating" class="col-7 d-flex flex-row-reverse">-->
    <!--                  <modal-product-parent-->
    <!--                    class="mr-2"-->
    <!--                    [product]="product"-->
    <!--                    [depots]="depots"-->
    <!--                    [suppliers]="suppliers"-->
    <!--                    [btnText]="'variant.choose'"-->
    <!--                    (result)="addChild($event)"-->
    <!--                    *ngIf="productDetailService.hasUpdateRole"-->
    <!--                  ></modal-product-parent>-->
    <!--                </div>-->
    <!--              </div>-->
    <!--              <table class="table mt-2" *ngIf="product.children && product.children.length > 0 || (this.isCreating && productCreatingService.childrenWithImagesToCreate?.length > 0)">-->
    <!--                <tbody class="images" [photoGalleryGroup]="{ index: 1 }">-->
    <!--                <tr *ngFor="let child of getChildren()">-->
    <!--                  <td>-->
    <!--                    <div class="flex-gap-10">-->
    <!--                      <ng-template [ngIf]="child.mainImage">-->
    <!--                        <div-->
    <!--                          class="align-self-center"-->
    <!--                          [photoGallery]="child.mainImage.url"-->
    <!--                          [photoGalleryCaption]="-->
    <!--                              child.name +-->
    <!--                              '<br>' +-->
    <!--                              (child.code ? ('product-form.code'|translate) + child.code : '') +-->
    <!--                              '<br>' +-->
    <!--                              (child.ean ? ('product-form.ean' | translate) + child.ean : '')-->
    <!--                            "-->
    <!--                        >-->
    <!--                          <div class="images-item">-->
    <!--                            <img-->
    <!--                              class="images-item-image"-->
    <!--                              [src]="getThumbUrl(child.mainImage)"-->
    <!--                              [alt]="child.name"-->
    <!--                            />-->
    <!--                          </div>-->
    <!--                        </div>-->
    <!--                      </ng-template>-->
    <!--                      <div class="align-self-center">-->
    <!--                        <a class="link-bold" *ngIf="!!child && !isCreating" [routerLink]="['/product', child.id]">{{-->
    <!--                          child.name-->
    <!--                          }}</a>-->
    <!--                        <div *ngIf="!!child && isCreating">{{ child.name }}</div>-->
    <!--                        <div class="product-details flex-gap-5 flex-wrap">-->
    <!--                          <div *ngIf="child.code">{{ 'product.code' | translate }}: {{ child.code }}</div>-->
    <!--                          <div *ngIf="child.ean">{{ 'product.ean' | translate }}: {{ child.ean }}</div>-->
    <!--                        </div>-->
    <!--                      </div>-->
    <!--                    </div>-->
    <!--                  </td>-->
    <!--                  <td title="Skladovost" class="text-center">-->
    <!--                    <div>{{ child.quantityStock ? child.quantityStock.toFixed(2) : 0 + ' ' + ('piece'|translate) }}</div>-->
    <!--                  </td>-->
    <!--                  <td *ngIf="!isCreating">-->
    <!--                    <btn-->
    <!--                      [title]="'product-form.remove' | translate"-->
    <!--                      [icon]="'far-trash-alt'"-->
    <!--                      [classes]="['btn-trash', 'btn-sm', 'float-right']"-->
    <!--                      (onEvent)="removeChild(child)"-->
    <!--                      *ngIf="!productDetailService.hasUpdateRole"-->
    <!--                    ></btn>-->
    <!--                  </td>-->
    <!--                </tr>-->
    <!--                </tbody>-->
    <!--              </table>-->
    <!--            </div>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </div>-->

    <div class="col-12 col-sm-12 col-md-12 col-lg-7 col-xl-7">
      <div class="card">
        <div class="row">
          <div class="col-8">
            <h3 class="card-title">{{ 'productMoves.load.list' | translate }}</h3>
          </div>
          <div class="col-4">
            <btn
              *ngIf="productDetailService.hasUpdateRole && product.children && product.children.length"
              [classes]="['btn-third', 'btn-sm', 'float-right']"
              [icon]="'far-chevron-right'"
              (onEvent)="updateVariants(['purchasePrice', 'purchaseCurrency', 'supplier'])"
            >
            </btn>
          </div>
        </div>
        <div class="row mt-2 d-flex">
          <div class="col d-flex flex-column" style="align-content: center">
            <form-row-input
              [label]="productDetailService.isCountByPiece ? 'purchasePrice.default.by-pack' : 'purchasePrice.default'"
              [class]="'input-unit'"
              [icon]="'fa-money-bill'"
              [(model)]="productDetailService.product.purchasePrice"
              [replaceComma]="true"
              [currency]="productDetailService.product.purchaseCurrency"
              [appendUnitCurrency]="true"
              [readonly]="!productDetailService.hasUpdateRole"
              data-cy="product-price-default"
            ></form-row-input>
            <form-row-input
              *ngIf="productDetailService.isCountByPiece"
              [label]="'purchasePrice.default.by-piece'"
              [class]="'input-unit'"
              [icon]="'fa-money-bill'"
              [(model)]="productDetailService.purchasePriceByPiece"
              [replaceComma]="true"
              [currency]="productDetailService.product.purchaseCurrency"
              [appendUnitCurrency]="true"
              [readonly]="!productDetailService.hasUpdateRole"
              data-cy="product-price-default"
            ></form-row-input>
          </div>
          <div class="col">
            <form-row-select
              [label]="'product.vatrate'"
              [options]="vats"
              [model]="vat"
              (modelChange)="productDetailService.product.vat.id = $event"
              [isSelectDisabled]="!productDetailService.hasUpdateRole"
              *ngIf="vats && vats.length > 0 && vats[0].id"
              data-cy="product-vat"
            ></form-row-select>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <form-row-select
              [model]="product.supplier?.id"
              (modelChange)="productDetailService.product.supplier = { id: $event, name: '' }"
              [label]="'supplier.default'"
              [icon]="'fa-person-carry'"
              [options]="suppliers"
              [dataCyAttribute]="'product-supplier-select'"
              [isSelectDisabled]="!productDetailService.hasUpdateRole"
            ></form-row-select>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
